export default {
  title: {
    en: 'Create Your Family!',
    ar: 'كوّن عائلتك!'
  },

  description: {
    en: 'Let’s make your Family Avatars! Don’t worry, you can change them anytime.',
    ar: 'لنصمم شخصيات العائلة الخاصة بك! لا تقلق، يمكنك تعديلها في أي وقت.'
  }
};
